// Shared, educational-only cannabinoid explanations.
// Used by the Learn page guide AND the Shop-page side info panel so the copy
// stays consistent. No medical claims.
export const CANNABINOID_ORDER = ["CBD", "CBG", "CBC", "CBN", "THC"];

export const CANNABINOID_INFO = {
  CBD: {
    name: "CBD",
    full: "Cannabidiol",
    tag: "Non-intoxicating",
    desc: "A naturally occurring, non-intoxicating cannabinoid found throughout the hemp plant. It won't get you 'high.' In our shop it shows up in gummies, other edibles, and infused drinks — commonly chosen for everyday balance.",
  },
  CBG: {
    name: "CBG",
    full: "Cannabigerol",
    tag: "Daytime · Non-intoxicating",
    desc: "Often called the 'mother cannabinoid' because the others form from it as the plant grows. Non-intoxicating and popular in daytime blends where people want to feel clear-headed.",
  },
  CBC: {
    name: "CBC",
    full: "Cannabichromene",
    tag: "Non-intoxicating",
    desc: "A lesser-known, non-intoxicating cannabinoid that works alongside CBD and CBG as part of hemp's full profile. You'll usually see it as a supporting player in full-spectrum products.",
  },
  CBN: {
    name: "CBN",
    full: "Cannabinol",
    tag: "Nighttime",
    desc: "A mild cannabinoid that forms naturally as THC ages. Frequently featured in nighttime products for a wind-down feel. Only lightly intoxicating in the small amounts used in our edibles.",
  },
  THC: {
    name: "THC",
    full: "Delta-9 THC (hemp-derived)",
    tag: "Intoxicating · 21+",
    desc: "The compound responsible for the classic euphoric 'high.' In hemp products it's federally limited to less than 0.3% by dry weight of the finished product. Start low and go slow — effects vary by person and can take 60–90 minutes to arrive in edibles and drinks. Do not drive or operate machinery.",
  },
};
